import React, { useMemo } from "react";
import "./catalog-game.scss";
import GameDesk from "./games-desk/GameDesk";
import { getSliceForCarousel } from "../../../utils/utils";
import Providers from "../providers/Providers";
import ErrorBoundary from "../../mui/error_boundary/ErrorBoundary";
import { useAppSelector } from "../../../store/index.ts";

export default function CatalogGame() {
  const getSlice = getSliceForCarousel;
  const gamesBonusS = useAppSelector((state) => state.games.bonusGames);
  const gamesHitS = useAppSelector((state) => state.games.hitGames);
  const liveGamesS = useAppSelector((state) => state.games.liveGames);
  const historyS = useAppSelector((state) => state.games.runningGames);

  const gamesBonus = useMemo(() => getSlice(gamesBonusS, 2) || [], [gamesBonusS]);
  const gamesHit = useMemo(() => getSlice(gamesHitS, 2) || [], [gamesHitS]);
  const liveGames = useMemo(() => getSlice(liveGamesS, 2) || [], [liveGamesS]);
  const history = useMemo(() => getSlice(historyS) || [], [historyS]);

  return (
    <section className="catalog-game">
      <div className="catalog-game__content">
        <ErrorBoundary>
          <GameDesk showAllLink={"/games/hit"} title={"Hit"} items={gamesHit} row2 />
        </ErrorBoundary>

        <ErrorBoundary>
          <GameDesk
            hideFavorites
            gameNavigate="bonus_game"
            showAllLink={"/games/bonus"}
            title={"Bonus Games"}
            items={gamesBonus}
            row2
          />
        </ErrorBoundary>

        <ErrorBoundary>
          <GameDesk showAllLink={"/games/live"} title={"Live Games"} items={liveGames} row2 />
        </ErrorBoundary>

        <ErrorBoundary>
          <Providers />
        </ErrorBoundary>

        <ErrorBoundary>
          <GameDesk
            id={"history"}
            showAllLink={"/games/history"}
            title={"History Games"}
            items={history}
          />
        </ErrorBoundary>
      </div>
    </section>
  );
}
